import {
  Button,
  Col,
  Divider,
  Form,
  Input,
  Row,
  Select,
  Typography,
} from "antd";
import { ArrowLeft, ArrowRight } from "lucide-react";

const { Title, Paragraph } = Typography;

const MEMBERSHIP_ACCESS_OPTIONS = [
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
  { value: "not_sure", label: "Not sure yet" },
];

const MEMBERSHIP_TYPE_OPTIONS = [
  { value: "free", label: "Free" },
  { value: "paid", label: "Paid" },
];

const MEMBERSHIP_REQUIRED_OPTIONS = [
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
  { value: "discounted", label: "Members get discounted pricing" },
];

function Step3AccessModel({
  onBack,
  onSubmit,
  submitting,
  otpSent,
  sendingOtp,
  onSendOtp,
  onResendOtp,
}) {
  return (
    <>
      <Title level={4} style={{ marginBottom: 4 }}>
        Community / Workshop Access Model
      </Title>
      <Paragraph type="secondary" style={{ marginBottom: 24 }}>
        Let us know how members access your community or workshop.
      </Paragraph>

      <Form.Item
        name="has_membership"
        label="Do your members get special access or pricing?"
        rules={[{ required: true, message: "Please select an option." }]}
      >
        <Select options={MEMBERSHIP_ACCESS_OPTIONS} placeholder="Select…" />
      </Form.Item>

      <Form.Item
        shouldUpdate={(prev, cur) => prev.has_membership !== cur.has_membership}
        noStyle
      >
        {({ getFieldValue }) =>
          getFieldValue("has_membership") === "yes" && (
            <>
              <Divider style={{ margin: "16px 0" }} />

              <Row gutter={[16, 0]}>
                <Col xs={24} sm={12}>
                  <Form.Item name="membership_name" label="Membership Name">
                    <Input placeholder="e.g. VIP Member" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item name="membership_type" label="Is this membership:">
                    <Select
                      options={MEMBERSHIP_TYPE_OPTIONS}
                      placeholder="Select…"
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Form.Item
                shouldUpdate={(prev, cur) =>
                  prev.membership_type !== cur.membership_type
                }
                noStyle
              >
                {({ getFieldValue: gfv }) =>
                  gfv("membership_type") === "paid" && (
                    <Form.Item name="monthly_price" label="Monthly Price (₹)">
                      <Input
                        type="number"
                        prefix="₹"
                        placeholder="e.g. 999"
                        style={{ maxWidth: 200 }}
                      />
                    </Form.Item>
                  )
                }
              </Form.Item>

              <Form.Item name="member_benefits" label="Member Benefits">
                <Input.TextArea
                  placeholder="Short description of what members get…"
                  rows={3}
                  showCount
                  maxLength={300}
                />
              </Form.Item>

              <Form.Item
                name="membership_required"
                label="Is membership required to attend your activities?"
              >
                <Select
                  options={MEMBERSHIP_REQUIRED_OPTIONS}
                  placeholder="Select…"
                />
              </Form.Item>
            </>
          )
        }
      </Form.Item>

      <Divider style={{ margin: "20px 0" }} />

      <Row gutter={[16, 0]} align="bottom">
        <Col xs={24} sm={12}>
          <Form.Item
            name="otp"
            label="Mobile OTP"
            rules={[
              { required: true, message: "Enter the OTP you received." },
              { pattern: /^\d{4,8}$/, message: "OTP should be 4–8 digits." },
            ]}
          >
            <Input
              placeholder="123456"
              inputMode="numeric"
              autoComplete="one-time-code"
              disabled={!otpSent}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} style={{ paddingBottom: 24 }}>
          {!otpSent ? (
            <Button onClick={onSendOtp} loading={sendingOtp}>
              Send OTP
            </Button>
          ) : (
            <Button
              type="link"
              onClick={onResendOtp}
              disabled={sendingOtp}
              style={{ paddingLeft: 0 }}
            >
              Resend OTP
            </Button>
          )}
        </Col>
      </Row>

      <Row justify="space-between" style={{ marginTop: 8 }}>
        <Col>
          <Button icon={<ArrowLeft size={14} />} onClick={onBack}>
            Back
          </Button>
        </Col>
        <Col>
          <Button
            type="primary"
            onClick={onSubmit}
            loading={submitting}
            disabled={!otpSent}
            icon={<ArrowRight size={14} />}
            iconPosition="end"
          >
            Complete Registration
          </Button>
        </Col>
      </Row>
    </>
  );
}

export default Step3AccessModel;
